import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: '/view/',
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '国盈首页'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/guarantee',
          name: 'guarantee',
          component: resolve => require(['@/view/Guarantee'], resolve),
          meta: {
            title: '保函查询'
          }
        },
        {
          path: '/cooperation',
          name: 'cooperation',
          component: resolve => require(['@/view/Cooperation'], resolve),
          meta: {
            title: '寻求合作'
          }
        },
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUsNew'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        // {
        //   path: '/mg',
        //   name: 'mg',
        //   component: resolve => require(['@/view/mg'],resolve),
        //   meta: {
        //     title: '鼎竑白虎网络欺骗诱捕系统'
        //   }
        // },
        // {
        //   path: '/ld',
        //   name: 'ld',
        //   component: resolve => require(['@/view/ld'],resolve),
        //   meta: {
        //     title: '鼎竑青龙漏洞管控平台'
        //   }
        // },
        // {
        //   path: '/ss',
        //   name: 'ss',
        //   component: resolve => require(['@/view/ss'],resolve),
        //   meta: {
        //     title: '鼎竑朱雀数据库审计系统'
        //   }
        // },
        // {
        //   path: '/rs',
        //   name: 'rs',
        //   component: resolve => require(['@/view/rs'],resolve),
        //   meta: {
        //     title: '鼎竑朱雀日志审计系统'
        //   }
        // },
        // {
        //   path: '/fin',
        //   name: 'fin',
        //   component: resolve => require(['@/view/fin'],resolve),
        //   meta: {
        //     title: '金融行业威胁防护方案'
        //   }
        // },
        {
          path: '/guaranteeDetail',
          name: 'guaranteeDetail',
          component: resolve => require(['@/view/GuaranteeDetail'],resolve),
          meta: {
            title: '保函详情'
          }
        },
        {
          path: '/case',
          name: 'case',
          component: resolve => require(['@/view/GuaranteeCase'],resolve),
          meta: {
            title: '保函案例'
          }
        },
        {
          path: '/caseDetail',
          name: 'caseDetail',
          component: resolve => require(['@/view/GuaranteeCaseDetail'],resolve),
          meta: {
            title: '保函案例详情'
          }
        },
        {
          path: '/news',
          name: 'news',
          component: resolve => require(['@/view/newsIndex'],resolve),
          meta: {
            title: '新闻资讯'
          }
        },
        {
          path: '/newsDetail',
          name: 'newsDetail',
          component: resolve => require(['@/view/news/newsDetail'],resolve),
          meta: {
            title: '新闻详情'
          }
        },
        // {
        //   path: '/salary',
        //   name: 'salary',
        //   component: resolve => require(['@/view/case/salary'],resolve),
        //   meta: {
        //     title: '【案例】民工工资担保'
        //   }
        // },
        // {
        //   path: '/promise',
        //   name: 'promise',
        //   component: resolve => require(['@/view/case/promise'],resolve),
        //   meta: {
        //     title: '【案例】履约保函'
        //   }
        // },
        // {
        //   path: '/quality',
        //   name: 'quality',
        //   component: resolve => require(['@/view/case/quality'],resolve),
        //   meta: {
        //     title: '【案例】质量担保'
        //   }
        // },
        // {
        //   path: '/advance',
        //   name: 'advance',
        //   component: resolve => require(['@/view/case/advance'],resolve),
        //   meta: {
        //     title: '【案例】预付款担保'
        //   }
        // },
        {
          path: '/trans',
          name: 'trans',
          component: resolve => require(['@/view/trans'],resolve),
          meta: {
            title: '交通行业数据安全解决方案'
          }
        },
        {
          path: '/search',
          name: 'search',
          component: resolve => require(['@/view/searchIndex'],resolve),
          meta: {
            title: '搜索关键词'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js